import { createSlice } from '@reduxjs/toolkit';
import { resetToInitialState } from '~/reducers/common-actions';

export const selectedUserGroupIdSlice = createSlice({
    name: 'selectedUserGroupId',
    initialState: null,
    reducers: {
        setSelectedUserGroupId: (state, action) => {
            return action.payload;
        },
        resetSelectedUserGroupId: () => {
            return null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetToInitialState, () => {
            return null;
        });
    }
});

export const { setSelectedUserGroupId, resetSelectedUserGroupId } =
    selectedUserGroupIdSlice.actions;

export const selectUserGroupId = (state) => state.selectedUserGroupId;

export default selectedUserGroupIdSlice.reducer;
